import qs from 'qs'

export const queryProjectsPage = (locale: QueryLocaleString) => {
  const query = qs.stringify(
    {
      locale: locale || 'en-US',
      fields: [
        'title',
        'richText',
        'introduction'
      ],
      populate: {
        ...queryFragmentSeo
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `projects-page?${query}`
}
